export const HITS_PER_PAGE = 48;
